import { NgModule } from '@angular/core';

import {
  ConfigureTranslateModule,
  registerLibTranslation,
  KeyAndLoader,
} from '@plugins/client/translate/loaders';

export const TRANSLATION_KEY = 'multilanguage';
const loader = (lang: string) => import(`./assets/i18n/${lang}.json`);

const source: KeyAndLoader = {
  loader,
  key: TRANSLATION_KEY,
};

export const loadTranslations = registerLibTranslation(source);

@NgModule()
@loadTranslations
export class MultilanguageTranslationModule extends ConfigureTranslateModule.configureLib(
  source,
) {}
